const schedule = [
  {
    date: { day: "21", month: "FEVEREIRO", fulldate: "2026-02-21" },
    description: "Treinamento Equipe MPV - SRM Maringá-PR",
  },
  {
    date: { day: "14", month: "MARÇO", fulldate: "2026-03-14" },
    description: "MPV - SRM Maringá-PR",
  },
  {
    date: { day: "02", month: "MAIO", fulldate: "2026-05-02" },
    description: "Aniversário 05 anos MC - Cambira-PR",
  },
  {
    date: { day: "23", month: "MAIO", fulldate: "2026-05-23" },
    description: "MPV - SRP Londrina-PR",
  },
  {
    date: { day: "04 a 07", month: "JUNHO", fulldate: "2026-06-04" },
    description: "Comitiva Casais - Barra Bonita-SP",
  },
  {
    date: { day: "20", month: "JUNHO", fulldate: "2026-06-20" },
    description: "MPV - SRM Maringá-PR",
  },
  {
    date: { day: "11", month: "JULHO", fulldate: "2026-07-11" },
    description: "MPV - SRP Londrina-PR",
  },
  {
    date: { day: "01", month: "AGOSTO", fulldate: "2026-08-01" },
    description: "MPV - Medianeira-PR",
  },
  {
    date: { day: "15", month: "AGOSTO", fulldate: "2026-08-15" },
    description: "MPV - SRM Maringá-PR",
  },
  {
    date: { day: "05", month: "SETEMBRO", fulldate: "2026-09-05" },
    description: "MPV - Medianeira-PR",
  },
  {
    date: { day: "12", month: "SETEMBRO", fulldate: "2026-09-12" },
    description: "MPV - SRP Londrina-PR",
  },
  {
    date: { day: "17", month: "OUTUBRO", fulldate: "2026-10-17" },
    description: "MPV - Medianeira-PR",
  },
  {
    date: { day: "31", month: "OUTUBRO", fulldate: "2026-10-31" },
    description: "MPV - SRP Londrina-PR",
  },
  {
    date: { day: "14", month: "NOVEMBRO", fulldate: "2026-11-14" },
    description: "MPV - SRM Maringá-PR",
  },
];

export default schedule;
